<template>
  <div style="padding:30px;box-sizing:border-box;">
    <el-row v-for="system in rows" :key="system.systemId" :gutter="20" v-loading="loadingSystem || loadingUi">
      <el-col :span="24" class="index-system-col">
        <el-popover :title="system.name" width="320" trigger="hover" placement="right">
          <span slot="reference">{{system.name}}</span>
          <div class="index-system-popover">
            <p class="url">{{system.url}}</p>
            <p class="desc">{{system.desc}}</p>
            <p class="time">创建时间: {{system.createTime}}</p>
            <p class="time">最后修改: {{system.createTime}}</p>
          </div>
        </el-popover>
      </el-col>
      <el-col v-for="ui in system.uis" :key="ui.uiId" :xl="4" :lg="6" :md="8" :sm="12" :xs="24" class="index-ui-col">
        <el-card>
          <div class="index-ui-title" slot="header">
            <el-tag type="success" size="mini">{{getUiType(ui)}}</el-tag>
            <img :src="getFavicon(ui)">
            <a :href="ui.url" target="_blank">{{ui.title}}</a>
          </div>
          <div class="index-ui-content">
            <p class="desc">{{ui.desc}}</p>
            <p class="time">创建时间: {{ui.createTime}}</p>
            <p class="time">最后修改: {{ui.createTime}}</p>
            <div class="index-ui-buttons">
              <el-button type="text" @click="toManagePage(ui)">页面管理</el-button>
              <el-button type="text" @click="toManageForm(ui)">表单管理</el-button>
              <el-button type="text" @click="toManageComponent(ui, c.group)" v-for="(c, i) in endpointGroupMap[ui.type]" :key="i">{{ c.text }}</el-button>
            </div>
          </div>
        </el-card>
      </el-col>
    </el-row>

    <el-dialog title="页面管理" :visible.sync="showPageManage" width="96%">
      <page-manage :endpoint="endpointOfPageManage" :uiId="uiIdOfPageManage"></page-manage>
    </el-dialog>

    <el-dialog title="表单管理" :visible.sync="showFormManage" width="96%">
      <form-manage :endpoint="endpointOfFormManage" :uiId="uiIdOfFormManage"></form-manage>
    </el-dialog>

    <el-dialog title="组件管理" :visible.sync="showComponentManage" width="96%">
      <component-manage :endpoint="endpointOfComponentManage" :uiId="uiIdOfComponentManage" :group="groupOfComponentManage"></component-manage>
    </el-dialog>
  </div>
</template>

<script>
import { fls } from '@/config'
import { getEndpointPath, endpointGroupMap } from './page/util'
import PageManage from './page/PageManage'
import FormManage from './page/FormManage'
import ComponentManage from './page/ComponentManage'

export default {
  name: 'index',
  components: {
    FormManage,
    PageManage,
    ComponentManage
  },
  data () {
    return {
      loadingSystem: false,
      systems: [],
      loadingUi: false,
      uis: [],
      rows: [],
      endpointOfPageManage: null,
      uiIdOfPageManage: null,
      showPageManage: false,
      endpointOfFormManage: null,
      uiIdOfFormManage: null,
      showFormManage: false,
      endpointOfComponentManage: null,
      uiIdOfComponentManage: null,
      groupOfComponentManage: null,
      showComponentManage: false,
      endpointGroupMap: []
    }
  },
  created () {
    this.loadingSystem = true
    this.loadingUi = true
    this.loadSystem()
    this.loadUi()
    this.endpointGroupMap = endpointGroupMap
  },
  methods: {
    loadSystem () {
      this.$http.request({
        method: 'get',
        url: '/api/cgSystems'
      }).then((res) => {
        this.systems = res.data.data
        this.loadingSystem = false

        if (!this.loadingUi) {
          this.mergeData()
        }
      })
    },
    loadUi () {
      this.$http.request({
        method: 'get',
        url: '/api/cgUis'
      }).then((res) => {
        this.uis = res.data.data
        this.loadingUi = false

        if (!this.loadingSystem) {
          this.mergeData()
        }
      })
    },
    mergeData () {
      let systems = this.systems
      let uis = this.uis
      for (let system of systems) {
        system.uis = []
        for (let ui of uis) {
          if (ui.systemId === system.systemId) {
            system.uis.push(ui)
          }
        }
      }
      this.rows = systems
    },
    getFavicon (ui) {
      return ui.favicon ? `${fls}/static-file/${ui.favicon}` : '/favicon.ico'
    },
    getUiType (ui) {
      if (ui.type === 'ELEMENT_UI') {
        return 'Element UI'
      }
      if (ui.type === 'VUX') {
        return 'VUX'
      }
      if (ui.type === 'FLUTTER') {
        return 'Flutter'
      }
    },
    toManagePage (ui) {
      this.uiIdOfPageManage = ui.uiId
      this.endpointOfPageManage = getEndpointPath(ui.type)
      this.showPageManage = true
    },
    toManageForm (ui) {
      this.uiIdOfFormManage = ui.uiId
      this.endpointOfFormManage = getEndpointPath(ui.type)
      this.showFormManage = true
    },
    toManageComponent (ui, group) {
      this.uiIdOfComponentManage = ui.uiId
      this.groupOfComponentManage = group
      this.endpointOfComponentManage = getEndpointPath(ui.type)
      this.showComponentManage = true
    }
  }
}
</script>

<style>
.index-system-col{color:#F56C6C;margin:10px 0;}
.index-system-popover{line-height:28px;}
.index-system-popover>.url{color:rgb(64, 158, 255);}
.index-system-popover>.desc{font-size:13px;color:#333;margin-bottom:8px;}
.index-system-popover>.time{font-size:13px;color:#999;}
.index-ui-col{margin-bottom:20px}
.index-ui-title{font-size:14px;}
.index-ui-title>.el-tag{float:right;}
.index-ui-title>img{width:14px;height:14px;vertical-align:middle;margin:-3px 4px 0 0;}
.index-ui-title>a{color:rgb(64, 158, 255);}
.index-ui-content{line-height:28px;}
.index-ui-content>.desc{font-size:13px;color:#333;margin-bottom:15px;}
.index-ui-content>.time{font-size:13px;color:#999;}
.index-ui-buttons{margin-top:10px;}
</style>
